'use strict';

var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var SVG = require('utils/svg');
var Consts = require('consts');

var color = {
    on: '#3584e4',
    off: '#77767b',
    chargingTemp: '#f66151',
};

var DrinkingWaterParametrizationView = Backbone.Marionette.ItemView.extend({
    template: require('components/devices/templates/controller/drinking_water_parametrization'),
    ui: {
        svg: '#js-drinking-water-graphic',
        chargin_temp: '#chargin_temp',
        'chargin_temp-text': '#chargin_temp-text',
        turn_off_limit: '#js-turn_off_limit',
        'turn_off_limit-text': '#js-turn_off_limit-text',
        turn_on_limit: '#js-turn_on_limit',
        'turn_on_limit-text': '#js-turn_on_limit-text',
        input: '.js-parameter-input',
    },
    events: {
        'mousedown .js-drag-button': 'startDrag',
        'mousemove ': 'doDrag',
        'click .tab-heading': 'changeTab',
        'click .subform-checkbox': 'toggleFeature',
        'change @ui.input': 'editValue',
        'keyup .js-time': 'editTime',
        'hide.timepicker': 'editTime',
    },

    initialize: function (options) {
        this.activeTab = options.activeTab || 'day';
        this.values = options.values;
        this.circuitNr = options.circuitNr;
        this.readMode = options.readOnly;
        if (!options.readOnly) {
            $(window).on('mouseup', $.proxy(this.stopDrag, this));
        }
        this.firstRender = true;
    },

    serializeData: function () {
        if (!this.values) {
            return;
        }
        var formElements = ['hystersis', 'chargingTempBoost', 'dwMaxTemperature', 'dwMinTemperature'];

        var desinfectionFormElements = $.extend(
            true,
            {},
            _.pick(this.values.values, [
                'desinfectionTemp',
                'desinfectionDay',
                'desinfectionStart',
                'desinfectionStop',
                'derivativActionTime',
            ])
        );

        desinfectionFormElements['desinfectionTemp'].type = 'day';
        desinfectionFormElements['desinfectionDay'].type = 'day';
        desinfectionFormElements['desinfectionDay'].dayNames = Consts.DayNames;
        desinfectionFormElements['desinfectionStart'].type = 'time';
        desinfectionFormElements['desinfectionStart'].val = this.getDisplayTime(
            desinfectionFormElements['desinfectionStart'].val,
            4
        );
        desinfectionFormElements['desinfectionStop'].type = 'time';
        desinfectionFormElements['desinfectionStop'].val = this.getDisplayTime(
            desinfectionFormElements['desinfectionStop'].val,
            4
        );
        desinfectionFormElements['derivativActionTime'].val = this.values.clockNumberToMinutes(
            desinfectionFormElements['derivativActionTime'].val
        );
        this.tabs = {
            day: {
                tabID: 'day',
                tabHeading: i18n.TR('Tagbetrieb'),
                formElements: _.pick(this.values.values, _.union(['dwTemperatureDay'], formElements)),
                active: this.activeTab === 'day',
                readOnly: this.readMode,
            },
            night: {
                tabID: 'night',
                tabHeading: i18n.TR('Nachtbetrieb'),
                formElements: _.pick(this.values.values, _.union(['dwTemperatureNight'], formElements)),
                active: this.activeTab === 'night',
                readOnly: this.readMode,
            },
            desinfection: {
                tabID: 'desinfection',
                tabHeading: i18n.TR('Thermische Desinfektion'),
                active: this.activeTab === 'desinfection',
                toggleOption: i18n.TR('Thermische Desinfektion'),
                toggleOptionID: 'thermalDesinfection',
                toggleValue: this.values.getValue('thermalDesinfection').val,
                formElements: desinfectionFormElements,
                readOnly: this.readMode || !this.values.getValue('thermalDesinfection').val,
            },
            special: {
                tabID: 'special',
                tabHeading: i18n.TR('Weitere Parameter'),
                active: this.activeTab === 'special',
                specialOptions: _.pick(
                    this.getSpecialOptions(),
                    function (opt) {
                        return opt.isVisible(this.options.device.attributes.schema.split('-')[0]);
                    },
                    this
                ),
            },
        };

        // remove special options tab, if there are non available
        if ($.isEmptyObject(this.tabs.special.specialOptions)) {
            delete this.tabs['special'];
        }

        return {
            tabs: this.tabs,
            readMode: this.readMode,
            showGraphic: this.activeTab === 'day' || this.activeTab === 'night',
            graph_config: this.getGraphConfig(),
            IDPrefix: this.readMode ? 'readonly-' : '',
        };
    },

    getSpecialOptions: function () {
        var specialElements = $.extend(
            true,
            {},
            _.pick(this.values.values, [
                'parallelPumpCancel',
                'parallelPumpLimitTemp',
                'timeTillPriority',
                'limitingFactorInvers',
            ])
        );

        specialElements['parallelPumpCancel'].val = this.values.clockNumberToMinutes(
            specialElements['parallelPumpCancel'].val
        );
        specialElements['timeTillPriority'].val = this.values.clockNumberToMinutes(
            specialElements['timeTillPriority'].val
        );
        // Hack: This Element occurs twice in the ui and hence there is a duplicated ID
        // when editing the suffix is removed
        specialElements['timeTillPriority-duplicate'] = specialElements['timeTillPriority'];
        function priorityIsVisible(scheme) {
            return (
                (scheme >= '1.1' && scheme <= '1.4') ||
                (scheme >= '3.1' && scheme <= '3.4') ||
                (scheme >= '4.1' && scheme <= '4.5') ||
                scheme.startsWith('5.1') ||
                scheme.startsWith('5.2') ||
                scheme.startsWith('9') ||
                (scheme >= '10.1' && scheme <= '10.3') ||
                scheme.startsWith('11') ||
                scheme.startsWith('12') ||
                scheme.startsWith('13') ||
                scheme.startsWith('15.0') ||
                scheme.startsWith('15.4') ||
                scheme.startsWith('15.5') ||
                scheme.startsWith('21')
            );
        }
        return [
            {
                readOnly: this.readMode || !this.values.getValue('ZPduringCharging').val,
                toggleOption: i18n.TR('ZP läuft während der Speicherladung'),
                toggleOptionID: 'ZPduringCharging',
                toggleValue: this.values.getValue('ZPduringCharging').val,
                gridPosition: 'first-form-value',
                isVisible: function (scheme) {
                    return !_.contains(
                        ['1.9', '11.0', '11.3', '11.9', '12.0', '12.9', '13.0', '13.9', '21.0', '21.9'],
                        scheme
                    );
                },
            },
            {
                readOnly: this.readMode || !this.values.getValue('intermediateHeating').val,
                toggleOption: i18n.TR('Zwischenheizen'),
                toggleOptionID: 'intermediateHeating',
                toggleValue: this.values.getValue('intermediateHeating').val,
                gridPosition: 'second-form-value',
                isVisible: function (scheme) {
                    return scheme.startsWith('2') || (scheme >= '4.1' && scheme <= '4.5');
                },
            },
            {
                readOnly: this.readMode || !this.values.getValue('priorityByInverseOp').val,
                toggleOption: i18n.TR('Vorrang (invers)'),
                toggleOptionID: 'priorityByInverseOp',
                toggleValue: this.values.getValue('priorityByInverseOp').val,
                gridPosition: 'third-form-value',
                isVisible: priorityIsVisible,
                formElements: _.pick(specialElements, ['timeTillPriority', 'limitingFactorInvers']),
            },
            {
                readOnly: this.readMode || !this.values.getValue('priorityBySetBackOp').val,
                toggleOption: i18n.TR('Vorrang (absenk)'),
                toggleOptionID: 'priorityBySetBackOp',
                toggleValue: this.values.getValue('priorityBySetBackOp').val,
                gridPosition: 'fourth-form-value',
                isVisible: priorityIsVisible,
                formElements: _.pick(specialElements, ['timeTillPriority-duplicate']),
            },
            {
                readOnly: this.readMode || !this.values.getValue('parallelPumpOp').val,
                toggleOption: i18n.TR('Pumpenparallellauf'),
                toggleOptionID: 'parallelPumpOp',
                toggleValue: this.values.getValue('parallelPumpOp').val,
                gridPosition: 'fifth-form-value',
                isVisible: function (scheme) {
                    return scheme.startsWith('8') || scheme == '9.5' || scheme == '9.6';
                },
                formElements: _.pick(specialElements, ['parallelPumpCancel', 'parallelPumpLimitTemp']),
            },
        ];
    },

    getGraphConfig: function () {
        var dayTemp = this.values.getValue('dwTemperatureDay').val / 10;
        var nightTemp = this.values.getValue('dwTemperatureNight').val / 10;
        var boost = this.values.getValue('chargingTempBoost').val / 10;
        var hystersis = this.values.getValue('hystersis').val / 10;
        var globalInfo = { activeTab: this.activeTab, readOnly: this.readMode };
        var self = this;
        var getHandleConfig = function (temp) {
            return {
                chargingTemp: $.extend(
                    {
                        id: 'chargingTemp',
                        value: temp + boost,
                        position: self.getSVGCoordinateYFromValue(temp + boost),
                        label: i18n.TR('Ladetemperatur'),
                        color: color.chargingTemp,
                    },
                    globalInfo
                ),
                on: $.extend(
                    {
                        id: 'on',
                        value: temp,
                        position: self.getSVGCoordinateYFromValue(temp),
                        label: i18n.TR('Einschalt GW'),
                        color: color.on,
                    },
                    globalInfo
                ),
                off: $.extend(
                    {
                        id: 'off',
                        value: temp + hystersis,
                        position: self.getSVGCoordinateYFromValue(temp + hystersis),
                        label: i18n.TR('Ausschalt GW'),
                        color: color.off,
                    },
                    globalInfo
                ),
            };
        };
        return {
            activeTab: this.activeTab,
            readOnly: this.readMode,
            day: getHandleConfig(dayTemp),
            night: getHandleConfig(nightTemp),
            axisConfig: SVG.getYAxisConfig(
                ['20 °C', '30 °C', '40 °C', '50 °C', '60 °C', '70 °C', '80 °C', '90 °C', '100 °C', '110 °C', '120 °C'],
                { x: -50, y: 10 }
            ),
        };
    },

    onRender: function () {
        if (this.readMode && !this.firstRender) {
            this.disableInteractivElements();
            return;
        }
        this.initTimePicker();
    },

    onShow: function () {
        this.firstRender = false;
        if (this.readMode) {
            this.disableInteractivElements();
            return;
        }
        this.initTimePicker();
    },

    onBeforeDestroy: function () {
        $(window).off('mouseup', this.stopDrag);
    },

    changeTab: function (e) {
        this.activeTab = this.removeIDPrefix(e.target.href.split('#')[1]);
        this.render();
    },

    toggleFeature: function (e) {
        if (this.readMode) {
            return;
        }
        this.values.setValue(e.target.id, e.target.checked ? 1 : 0);
        this.render();
    },

    editTime: function (e) {
        if (e.type == 'keyup' && e.keyCode != 13 && e.keyCode != 9) {
            return;
        }
        var fullID = e.target.id;
        var id = fullID.split('-')[0];
        var value = parseInt(e.target.value.split(':').join(''));
        this.values.setValue(id, value);
        var time = this.getDisplayTime(this.values.getValue(id).val);
        $('#' + fullID).val(time);
    },

    editValue: function (e) {
        var value = e.target.value;
        var fullID = e.target.id;
        var id = fullID.split('-')[0];
        if (this.values.getValue(id).unit === '°C') {
            value = parseInt(value) * 10;
            if (['dwMaxTemperature', 'dwMinTemperature'].includes(id)) {
                this.values.setDrinkingTemperatureLimit(id, value);
            } else {
                this.values.setValue(id, value);
            }
            e.target.value = this.values.getValue(id, value).val / 10;
            if (['day', 'night'].includes(this.activeTab)) {
                this.updateModel();
                this.updateUI();
            }
            return;
        }

        if (['derivativActionTime', 'timeTillPriority', 'parallelPumpCancel', 'timeTillPriority'].includes(id)) {
            this.values.setValue(id, this.values.minutesToClockNumber(value));
            var time = this.values.clockNumberToMinutes(this.values.getValue(id, value).val);
            e.target.value = time;
            // Hack: this element exists twice, so we have to update it twice
            if (id === 'timeTillPriority') {
                $('#timeTillPriority-duplicate').val(time);
                $('#timeTillPriority').val(time);
            }
            return;
        }
        this.values.setValue(id, value);
        e.target.value = this.values.getValue(id, value).val;
    },

    startDrag: function (e) {
        if (this.readMode) {
            return;
        }
        $(e.currentTarget).children('g.pressed').show();
        this.dragging = true;
        var mousePosition = Misc.getCoordinates(e);
        mousePosition.x = Math.round(mousePosition.x * 10) / 10;
        mousePosition.y = Math.round(mousePosition.y * 10) / 10;
        this.startMousePosition = SVG.getSVGCoordinatesFromScreen(this.ui.svg[0], mousePosition.x, mousePosition.y);

        this.targetID = e.currentTarget.id;
        this.oldYPosition = parseInt($(e.currentTarget).attr('y'));
    },

    doDrag: function (e) {
        if (this.readMode || !this.dragging) {
            return;
        }
        var mousePosition = Misc.getCoordinates(e);
        var svgPosition = SVG.getSVGCoordinatesFromScreen(this.ui.svg[0], mousePosition.x, mousePosition.y);
        var delta = Math.round((svgPosition.y - this.startMousePosition.y) / 3) * 3;
        if (Math.abs(delta) > 0) {
            this.mouveButton(delta);
            this.updateModelFromGraphic();
            this.updateUI();
        }
    },

    mouveButton: function (delta) {
        $('#' + this.targetID).attr('y', this.oldYPosition + delta);
    },

    updateUI: function () {
        // update input fields
        _.each(
            this.tabs[this.activeTab].formElements,
            function (element, ID) {
                $('#' + ID + '-' + this.activeTab).val(this.values.getValue(ID).val / 10);
            },
            this
        );

        // only night and day do have a graphic
        if (this.activeTab != 'day' && this.activeTab != 'night') {
            return;
        }

        // update graphic
        var graphicConfig = this.getGraphConfig();
        if (this.activeTab === 'day') {
            _.each(
                graphicConfig['day'],
                function (element, key) {
                    $('#' + element.id).attr('y', element.position);
                    $('#' + element.id + '-text').text(element.value + '°C');
                },
                this
            );
            _.each(
                $('.night-marker'),
                function (element) {
                    var id = element.id.split('-')[1];
                    $(element).attr('transform', 'translate(0,' + graphicConfig.night[id].position + ')');
                    $('#' + element.id + '-text').text(graphicConfig.night[id].value + '°C');
                },
                this
            );
        } else {
            _.each(
                graphicConfig['night'],
                function (element, key) {
                    $('#' + element.id).attr('y', element.position);
                    $('#' + element.id + '-text').text(element.value + '°C');
                },
                this
            );
            _.each(
                $('.day-marker'),
                function (element) {
                    var id = element.id.split('-')[1];
                    $(element).attr('transform', 'translate(0,' + graphicConfig.day[id].position + ')');
                    $('#' + element.id + '-text').text(graphicConfig.day[id].value + '°C');
                },
                this
            );
        }
    },

    updateModel: function () {
        // Write all values with their current value to enforce possibly changed constraints
        this.values.setTurnOnLimit('dwTemperatureDay', this.values.getValue('dwTemperatureDay').val);
        var dayTemp = this.values.getValue('dwTemperatureDay').val;
        this.values.setTurnOnLimit('dwTemperatureNight', this.values.getValue('dwTemperatureNight').val);
        this.values.setTurnOffLimit(dayTemp + this.values.getValue('hystersis').val, true);
        this.values.setChargingTemperatur(dayTemp + this.values.getValue('chargingTempBoost').val, true);
    },

    updateModelFromGraphic: function () {
        var position = parseInt($('#' + this.targetID).attr('y'));
        if (isNaN(position)) {
            return;
        }
        var value = this.getValueFromSVGCoordinateY(position);
        switch (this.targetID) {
            case 'on':
                this.values.setTurnOnLimit(this.activeTab === 'day' ? 'dwTemperatureDay' : 'dwTemperatureNight', value);
                break;
            case 'off':
                this.values.setTurnOffLimit(value, this.activeTab === 'day');
                break;
            case 'chargingTemp':
                this.values.setChargingTemperatur(value, this.activeTab === 'day');
                break;
        }
    },

    stopDrag: function (e) {
        if (this.readMode) {
            return;
        }
        // graphic should be invisible in other cases
        if (this.activeTab != 'day' && this.activeTab != 'night') {
            return;
        }
        e.stopImmediatePropagation();
        $('g.pressed').hide();
        this.dragging = false;
    },

    disableInteractivElements: function () {
        // remove all interactiv ids and classes.
        _.each($('#js-parameter-container').find('*'), function (element) {
            delete element.id;
        });
        SVG.removeClass($('.js-drag-button'), 'js-drag-button clickable');
        _.each($('svg'), function (element) {
            element.id = '';
        });
        if (document.getElementById('on-text')) {
            document.getElementById('on-text').id = '';
            document.getElementById('off-text').id = '';
            document.getElementById('chargingTemp-text').id = '';
        }
    },

    getValues: function () {
        var result = { register: [], coils: [] };
        _.each(_.pick(this.values.values, this.values.drinkingWaterRegisterIDs), function (value) {
            result.register.push({ address: value.nr, value: Misc.getUnsignedInt(value.val) });
        });
        // maxChargingTempActive is not writeable
        _.each(
            _.pick(this.values.values, _.without(this.values.drinkingWaterCoilIDs, 'maxChargingTempActive')),
            function (value) {
                result.coils.push({ address: value.nr, value: value.val === 1 });
            }
        );

        return result;
    },

    initTimePicker: function () {
        var self = this;
        if (this.readMode) {
            return;
        }
        // wait for elements to be available for modification
        setTimeout(function () {
            var options = {};
            if (self.activeTab === 'special') {
                options.minuteStep = 1;
                options.maxHours = 1;
            }
            Misc.initTimePicker(undefined, options);
        }, 1000);
    },

    removeIDPrefix: function (ID) {
        if (ID.startsWith('readonly-')) {
            return ID.substring(9);
        }
        return ID;
    },

    getDisplayTime: function (input) {
        var value = Misc.leadingZero(input, 4);
        return (value.startsWith('0') ? value.substring(1, 2) : value.substring(0, 2)) + ':' + value.substring(2);
    },

    getSVGCoordinateYFromValue: function (value) {
        return (120 - value) * 3 - 1.5;
    },

    getValueFromSVGCoordinateY: function (position) {
        return -Math.round((position + 1.5) / 3 - 120) * 10;
    },
});

module.exports = DrinkingWaterParametrizationView;
